import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './pledge.less'
import { getI18n, getI18nBase } from 'client/i18n'
import MoneyTextBox from 'components/common/money_text_box'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { trackClick } from 'lib/fpti_analytics'
import { toCFPBStringId } from 'client/lib/cfpb'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import { HeadingText, Button } from '@paypalcorp/pp-react'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

const i18n = getI18n('components/chip_in_glimpse/pledge')
const i18nBase = getI18nBase('components/chip_in_glimpse/pledge')

class Pledge extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    onPledge: PropTypes.func,
    currency: PropTypes.string,
    campaignType: PropTypes.string,
    handleSubmit: PropTypes.func,
    router: routerShape.isRequired,
    minAmount: PropTypes.number,
    isCrowdfunding: PropTypes.bool,
    campaignTitle: PropTypes.string,
  }

  handleSubmit = formValues => {
    sendEnsightenEvent('MoneyPoolPledgeFin')
    trackClick({
      clickName: 'dw_giving_fundraiser_pledge_confirm_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_pledge_confirm_pressed',
        amount: formValues && formValues.pledge,
        currency: this.props.currency,
      },
    })
    return this.props
      .onPledge(formValues)
      .then(() => this.postPledge(formValues))
  }
  postPledge = formValues => {
    if (this.props.campaignType === CROWD_FUNDING) {
      const { pathname } = this.props.router.location
      const nextPathname = `${pathname}/complete`
      this.props.router.push({
        pathname: `${nextPathname}`,
        state: {
          params: {
            currency: this.props.currency,
            campaignTitle: this.props.campaignTitle,
            pledge: formValues.pledge,
          },
        },
      })
    } else {
      exitGlimpse('chip_in', this.props.router)
    }
  }

  render() {
    const {
      fields: { pledge },
      handleSubmit,
      minAmount,
      isCrowdfunding,
    } = this.props

    const subTitle = isCrowdfunding ? (
      <HeadingText size="md">{i18n('subtitle_cf')}</HeadingText>
    ) : (
      i18n('subtitle')
    )

    return (
      <div>
        {!isCrowdfunding && <div styleName="title">{i18n('title')}</div>}
        <div>{subTitle}</div>
        <form onSubmit={handleSubmit(this.handleSubmit)} styleName="form">
          <MoneyTextBox
            {...pledge}
            currencyCode={this.props.currency}
            title={i18nBase('amount')}
            autoFocus={true}
            minAmount={minAmount}
          />
          <div styleName="text">
            {i18n(`${isCrowdfunding ? 'text_cf' : toCFPBStringId('text')}`)}
          </div>
          <Button styleName="done-button" data-testid="pledge-button">
            {i18n(`${isCrowdfunding ? 'pledge_cf' : 'pledge'}`)}
          </Button>
        </form>
      </div>
    )
  }
}

export default cssModules(Pledge, styles)
